/* Version Drawer */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.product_drawer_open');
    if (!trigger) return;

    const popupClass = trigger.getAttribute('popup_id');
    if (!popupClass) return;

    // close any open popup first
    document.querySelectorAll('.Included_maindrawer_new.open')
      .forEach(el => el.classList.remove('open'));

    const target = document.querySelector(`.Included_maindrawer_new.${popupClass}`);
    if (!target) return;

    target.classList.add('open');
    document.body.classList.add('product_drawer_is_open');

    // Autoplay can be refused outside a user gesture (macOS Low Power Mode,
    // Safari settings), which leaves the drawer's render video frozen on its
    // poster. This click IS a gesture, so attaching and playing here is allowed.
    // Only touch media the opened panel will actually show: same panel-width
    // column (skips off-track carousel slides) and above the fold.
    var lazy = window.__galleryVideoLazy;
    var panelBox = target.getBoundingClientRect();
    target.querySelectorAll('video[autoplay]').forEach(function (video) {
      var box = video.getBoundingClientRect();
      if (box.width < 2 || box.top > window.innerHeight) return;
      if (box.left - panelBox.left >= panelBox.width) return;
      if (!video.dataset.lazyVideoAttached && lazy && typeof lazy.attach === 'function') {
        lazy.attach(video);
      } else if (video.paused) {
        var played = video.play();
        if (played && typeof played.catch === 'function') played.catch(function () {});
      }
    });
  });

  document.addEventListener('click', function (e) {
    const closeTrigger = e.target.closest('.product_drawer_overlay_new, .product_drawer_close');
    if (!closeTrigger) return;

    document.body.classList.remove('product_drawer_is_open');

    document.querySelectorAll('.Included_maindrawer_new.open')
      .forEach(el => el.classList.remove('open'));
  });
/* Version Drawer */